<div class="flex min-h-screen flex-wrap bg-background">
  <aside
    class="flex flex-[1_1_420px] flex-col gap-12 bg-[var(--navy)] p-8 text-primary-foreground md:p-12"
  >
    <a routerLink="/" class="flex items-center gap-2 text-primary-foreground">
      <span class="logo">AP</span>
      <span class="font-semibold">AGW Agency Portal</span>
    </a>
    <div class="mt-auto max-w-[440px]">
      <h2 class="m-0 text-[28px] leading-tight font-medium tracking-tight">
        Your NDC agency, set up in minutes.
      </h2>
      <ul class="m-0 mt-7 flex list-none flex-col gap-3.5 p-0 text-sm text-[oklch(0.85_0.02_256)]">
        <li class="flex items-start gap-3">
          <app-icon name="check" class="mt-0.5 text-[oklch(0.75_0.15_28.1)]" />
          Connect NDC airlines and manage your agency credentials
        </li>
        <li class="flex items-start gap-3">
          <app-icon name="check" class="mt-0.5 text-[oklch(0.75_0.15_28.1)]" />
          Give your agents BookingPad, the AGW agent desktop
        </li>
        <li class="flex items-start gap-3">
          <app-icon name="check" class="mt-0.5 text-[oklch(0.75_0.15_28.1)]" />
          Enable partner apps built on the AGW API
        </li>
      </ul>
    </div>
    <p class="m-0 mt-auto text-xs text-[oklch(0.7_0.03_256)]">
      Authentication is brokered via AGW Keycloak.
    </p>
  </aside>

  <main class="flex min-w-0 flex-[999_1_560px] items-center justify-center px-6 py-12">
    <form
      class="flex w-full max-w-[620px] flex-col"
      [formGroup]="accountForm"
      (ngSubmit)="saveChanges()"
    >
      <h1 class="title">Register your agency</h1>
      <p class="desc">
        Fields marked
        <span class="req">*</span>
        are required.
      </p>

      <div class="form-grid mt-7">
        <div class="field span-all">
          <label class="label" for="email">
            Email contact
            <span class="req">*</span>
          </label>
          <input
            id="email"
            class="input"
            type="email"
            formControlName="email"
            placeholder="e.g. no-reply@airgateway.com"
            (blur)="onEmailBlur($event)"
            error
          />
          <p class="hint">
            It becomes your login, and its domain names your agency. We email you an invitation to
            set up your account.
          </p>
        </div>
        <div class="field span-all">
          <label class="label" for="agency">Agency ID</label>
          <input
            id="agency"
            class="input"
            formControlName="agency"
            placeholder="Inferred from email"
          />
        </div>
        <div class="field span-all">
          <label class="label" for="company_name">
            Company name
            <span class="req">*</span>
          </label>
          <input
            id="company_name"
            class="input"
            formControlName="company_name"
            placeholder="e.g. AirGateway GmbH"
            error
          />
        </div>
        <div class="field span-all">
          <label class="label" for="street">
            Agency address
            <span class="req">*</span>
          </label>
          <input
            id="street"
            class="input"
            formControlName="street"
            placeholder="e.g. Gutzkowstr. 8"
            error
          />
        </div>
        <div class="field">
          <label class="label" for="postal_code">
            Zip code
            <span class="req">*</span>
          </label>
          <input
            id="postal_code"
            class="input"
            formControlName="postal_code"
            placeholder="e.g. 10827"
            error
          />
        </div>
        <div class="field">
          <label class="label" for="phone_contact">
            Phone number
            <span class="req">*</span>
          </label>
          <input
            id="phone_contact"
            class="input"
            type="tel"
            formControlName="phone_contact"
            placeholder="e.g. +491570000000"
            error
          />
        </div>
      </div>

      <button type="submit" class="btn btn-primary btn-block mt-7" [disabled]="submitting">
        {{ submitting ? 'Creating account…' : 'Create new account' }}
      </button>
      <p class="m-0 mt-4 text-center text-xs text-muted-foreground">
        By continuing you agree to the
        <a href="https://airgateway.com/tos/" target="_blank" rel="noopener">
          AirGateway Terms of Service
        </a>
        . Already registered?
        <button
          type="button"
          class="cursor-pointer border-0 bg-transparent p-0 text-xs text-primary"
          (click)="login()"
        >
          Sign in
        </button>
      </p>
    </form>
  </main>
</div>
